import React from 'react';
import type { ExportProgressState } from '../../hooks/useExportProgress';

interface ExportProgressModalProps {
  state: ExportProgressState;
}

/** 导出进度弹窗：导出期间居中展示当前阶段与进度条 */
const ExportProgressModal: React.FC<ExportProgressModalProps> = ({ state }) => {
  if (!state.visible) return null;

  const isWord = state.format === 'word';

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-[360px] mx-4">
        <div className="flex items-center gap-3 mb-5">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${isWord ? 'bg-blue-100' : 'bg-red-100'}`}>
            <svg
              className={`w-5 h-5 ${isWord ? 'text-blue-600' : 'text-red-600'} ${state.progress < 100 ? 'animate-pulse' : ''}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              {state.progress >= 100 ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
              )}
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-slate-800 text-sm">
              {state.progress >= 100 ? '导出完成' : `正在导出 ${isWord ? 'Word' : 'PDF'} 文档`}
            </p>
            <p className="text-xs text-slate-500 truncate mt-0.5">{state.stage}</p>
          </div>
          <span className="text-sm font-medium text-slate-600 flex-shrink-0">{state.progress}%</span>
        </div>
        <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden">
          <div
            className={`h-2 rounded-full transition-all duration-500 ${isWord ? 'bg-blue-600' : 'bg-red-600'}`}
            style={{ width: `${state.progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ExportProgressModal;
